import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {ShopCreature} from "@/store/shop/types";
import TextUtils from "@/utils/text-utils";
import {Keys} from "@/constants/key";

export class AmetistHeroPanel extends ShopCreaturePanel {

    protected getPriceText(sc: ShopCreature): string {
        return String(sc.price);
    }

    protected getBtnIcAtlas(): string | undefined {
        return undefined;
    }

    protected getBtnIcImg(): string {
        return Keys.IC_100_AMETIST;
    }
}